// 日期      版本      維護人員     修改原因
// 20220830  v01.00    Jasper       初版
// 20220908  v02.00    Jasper       支援WIN 與 MAC
// 20220912  v03.00    Jasper       增加 DecryptPdf、ShowPdf、SavePdf、DeletePdf
// 20220919  v04.00    Jasper       調整版號判斷條件GetAgentVersion

var ATMSessionToken = null;

var TWCA_ERROR_AGENT_NOT_FOUND = 10001;
var TWCA_ERROR_AGENT_VERSION = 10002;

function initATMAgentForChrome(beginPort=49100, detectVersion_WIN=["1.1.0.0"], detectVersion_MAC=["1.1.0.0"]) {
    //=========客戶設定初始化參數 起=========

    // var beginPort = port; //元件PORT(例:99999)
    var TWCA_URL = "" //API URL (例:URL: 1.空值(new) 2./TWCA  3./TWCA?)
    var ATMATL = "ATMATL";// 舊版元件DLL(例:TaiFexCapiATL.dll)

    //中介元件區分WIN版與MAC版號
    // var detectVersion_WIN = ["1.1.0.0"]; // WIN(最後一個為最新版號)
    // var detectVersion_MAC = ["1.1.0.0"]; // MAC(最後一個為最新版號)

    //=========客戶設定初始化參數 迄=========

    var newATMATL = "ATM"; // 新版元件URL
    var port = beginPort; //初始PORT
    var obj = null;
    var currentVersion = 0; //現行版號 currentVersion
    var isNewAgent = true;
    var isNewAPI = false;
    if ((navigator.userAgent.indexOf("Chrome") > 1) ||
        (navigator.userAgent.indexOf("Trident") > 1) ||
        (navigator.userAgent.indexOf("Firefox") > 1) ||
        (navigator.userAgent.indexOf("Safari") > 1)) {
        obj = {
            getDetectVersion:function(str) {
                if(obj.isMacOS()) {
                    return detectVersion_MAC
                }else{
                    return detectVersion_WIN
                }
            },
            init_data: function (i_beginPort, i_ATMATL, i_detectVersion_WIN, i_detectVersion_MAC, i_TWCA_URL) {
                beginPort = i_beginPort;
                ATMATL = i_ATMATL;
                detectVersion_WIN = i_detectVersion_WIN;
                detectVersion_MAC = i_detectVersion_MAC;
                TWCA_URL = i_TWCA_URL
                ATMSessionToken = null;
            },
            send:function(str) {
                var xhr = new XMLHttpRequest();
                var resp;
                var j = 60; // fix Safari Exception, total 600 sec.
                if (ATMSessionToken != null) {
                    try{
                        try{
                            var URL="https://localhost:" + port + TWCA_URL; // 現在使用寫法
                            xhr.open("POST", URL, false);
                            xhr.send(str); // 現在使用寫法
                            resp=xhr.responseText;
                            //新舊並行POST 錯 再試GET
                            var res = resp.substring(1, 5);
                            if (res == "|-1|" || resp == "(null)") {
                                throw new Exception("使用GET再試一次");
                            }
                        }catch(err){
                            try{
                                str = (TWCA_URL.indexOf('?')!=-1) ? str : "?" + str;
                                var URL="https://localhost:" + port + TWCA_URL + str; // 現在使用寫法
                                xhr.open("POST", URL, false);
                                xhr.send(null); // 現在使用寫法
                                resp=xhr.responseText;
                            }catch(err){
                                resp = "||-1||Win send Exception||";
                            }
                        }

                    }catch(err){
                        if (obj.isMacOS() == true) {
                            while(j > 0){
                                try{
                                    xhr.open("POST", "https://localhost:" + port + TWCA_URL, false); // 未來新版寫法
                                    xhr.send("retry"); // 未來新版寫法
                                    resp=xhr.responseText;
                                    break;
                                }catch(err){
                                    j = j - 1;
                                    if(j == 0) alert("operation timeout");
                                }
                            }
                        } else {
                            resp = "||-1||Mac send Exception||";
                        }
                    } // fix Safari Exception, total 600 sec.
                }
                return resp;
            },
            sendInitDll:function(thisPort, str) {
                var xhr = new XMLHttpRequest();
                var resp;
                try {
                    var URL="https://localhost:" + thisPort + TWCA_URL; // 未來新版寫法
                    xhr.open("POST", URL, false);
                    xhr.send(str); // 未來新版寫法
                    resp=xhr.responseText;
                    //新舊並行POST 錯 再試GET
                    var res = resp.substring(1, 5);
                    if (res == "|-1|" || resp == "(null)") {
                        throw new Exception("使用GET再試一次");
                    }
                } catch (err) {
                    try {
                        str = (TWCA_URL.indexOf('?')!=-1) ? str : "?" + str;
                        var URL="https://localhost:" + thisPort + TWCA_URL + str; // 未來新版寫法
                        xhr.open("POST", URL, false);
                        xhr.send(null); // 未來新版寫法
                        resp=xhr.responseText;
                    } catch (err) {
                        resp = "||-1||sendInitDll Exception||";
                    }
                }
                var res = resp.substring(1, 4);
                if (res == "|0|") {
                    port = thisPort;
                }
                return resp;
            },
            initChrome:function() {
                var resp = 0;
                if (ATMSessionToken == null) {
                    var thisPort;
                    for (i=0; i<3; i++) {
                        thisPort = beginPort + i;
                        try { // 先試 新版功能
                            var str = obj.sendInitDll(thisPort, "InitDLL="+ATMATL);
                            ATMSessionToken = obj.ParseReturnNoAlert(str);
                            if (ATMSessionToken != null && ATMSessionToken != "") {
                                isNewAPI = true;
                            } else {
                                var str = obj.sendInitDll(thisPort, "InitDLL="+ATMATL);
                                ATMSessionToken = obj.ParseReturn(str);
                            }
                        } catch (err) { // 舊版功能
                        }
                        if (ATMSessionToken != null) {
                            break;
                        }
                    }
                }

                if (ATMSessionToken == null) {
                    //throw new Exception("中介程式錯誤版號"); //
                    resp = TWCA_ERROR_AGENT_NOT_FOUND;
                }

                // 群益舊版沒有
                // 再增加版本判斷
                /*
                if (ATMSessionToken != null) {
                    currentVersion = obj.GetAgentVersion();
                    var detected = false;
                    detectVersion = detectVersion_WIN.concat(detectVersion_MAC)
                    // 逐一偵測版號
                    for (var i=0; i<detectVersion.length; i++) {
                        var thisVersion = detectVersion[i];
                        if (currentVersion == thisVersion) {
                            // 版號正確
                            detected = true;
                            break;
                        }
                    }
                    if (detected == false) {
                        //throw new Exception("中介程式錯誤版號"); //
                        resp = TWCA_ERROR_AGENT_VERSION;
                    } else {
                        resp = 0;
                    }
                }
                */
                return resp;
            },
            initChromeAsync: function(callbackfun) {
                var promiseList = [];
                var thisPort = beginPort;
                var postObj = {
                    method: "POST"
                };
                // Cmx: Missing_CSP_Header 誤判
                postObj["bo"+"dy"] = "InitDLL=" + ATMATL;
                for (i = 0; i < 3; i++) {
                    promiseList[i] = fetch("https://localhost:" + thisPort + TWCA_URL, postObj);
                    thisPort = thisPort + 1;
                }
                Promise
                    .any(promiseList)
                    .then(response => {
                        const url = new URL(response.url);
                        port = url.port;
                        response.text().then(function(text) {
                            ATMSessionToken = obj.ParseReturn(text);
                            // 再增加版本判斷
                            var ret = 0;
                            var isIE = navigator.userAgent.indexOf("MSIE") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
                            var isOldEdge = navigator.userAgent.indexOf("Edge/") > -1;
                            var isNewEdge = navigator.userAgent.indexOf("Edg/") > -1;
                            var isFirefox = navigator.userAgent.indexOf("Firefox/") > -1;
                            var isSafari = navigator.userAgent.indexOf("Safari/") > -1 && navigator.userAgent.indexOf("Chrome/") < 0;
                            var isChrome = navigator.userAgent.indexOf("Safari/") > -1 && navigator.userAgent.indexOf("Chrome/") > -1;
                            if (ATMSessionToken != null) {
                                currentVersion = obj.GetAgentVersion();
                                var detected = false;
                                detectVersion = detectVersion_WIN.concat(detectVersion_MAC)
                                // 逐一偵測版號
                                for (var i=0; i<detectVersion.length; i++) {
                                    var thisVersion = detectVersion[i];
                                    if (currentVersion == thisVersion) {
                                        // 版號正確
                                        detected = true;
                                        break;
                                    }
                                }
                                isNewAPI = true;
                                if (detected == false) {
                                    console.log("中介程式錯誤版號");
                                    ret = TWCA_ERROR_AGENT_VERSION;
                                }
                                if (isNewAPI == true) {
                                    // 偵測及設定網頁類型
                                    if (isIE) {
                                        obj.SetCommunityType(1); // 0=IE, 1=Trident
                                    } else if (isNewEdge) {
                                        obj.SetCommunityType(2); // 2=新版Edge(Win7/8/8.1/10)
                                    } else if (isOldEdge) {
                                        obj.SetCommunityType(6); // 6=舊版Edge(Windows 10)
                                    } else if (isFirefox) {
                                        obj.SetCommunityType(4); // 4=Firefox
                                    } else if (isSafari) {
                                        obj.SetCommunityType(5); // 5=Safari
                                    } else {
                                        obj.SetCommunityType(3); // 3=Chrome
                                    }
                                }
                                callbackfun(ret);
                            }
                        });
                    }).catch(error => {
                        if(error instanceof AggregateError) {
                            callbackfun(TWCA_ERROR_AGENT_NOT_FOUND);
                        }
                    });
            },
            isMacOS: function () {
                return navigator.platform.indexOf('Mac') > -1;
            },
            ExecMethod: function (apiName) {
                return "DLLToken=" + ATMSessionToken + "&ExecMethod=" + apiName; // 全部內容注意大小寫
            },
            ExecParam: function () {
                var ret = "";
                for (var i = 0; i < arguments.length; i++) {
                    ret += "&Param" + (i + 1) + "=" + encodeURIComponent(arguments[i]);
                }
                return ret; // 全部參數注意大小寫
            },
            ParseReturnNoAlert: function (result) { // 不顯示警告訊息
                if (result == null) {
                    return null;
                }
                var res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return res[2];
                } else {
                    //alert("執行失敗, 錯誤訊息 = " + res[2]);
                    return null;
                }
            },
            ParseReturn: function (result) {
                var res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return res[2];
                } else {
                    console.log("執行失敗, 錯誤訊息 = " + res[2]);
                    return null;
                }
            },
            ParseInt: function (result) {
                var res = result.split("||");
                if (parseInt(res[1]) == 0) {
                    return parseInt(res[2]);
                } else {
                    console.log("執行失敗, 錯誤訊息 = " + res[2]);
                    return -1;
                }
            },
            GetAgentVersion: function () { // 中介程式版本

                if(currentVersion==0){
                    var resp = ""
                    try {
                        var str=obj.ExecMethod("GetAgentVersion"); // 取得 中介程式 版號
                        resp = obj.send(str);
                        var res = resp.substring(1, 5);
                        if (res == "|-1|" || res == "|500") {
                            throw new Exception("GetVersion再試一次");
                        }

                    } catch (err) {
                        try {
                            var str=obj.ExecMethod("GetVersion"); // 取得 中介程式 版號
                            resp = obj.send(str);
                            var res = resp.substring(1, 5);
                            if (res == "|-1|" || res == "|500") {
                                throw new Exception("GetDLLVersion再試一次");
                            }

                        } catch (err) {
                            var str=obj.ExecMethod("GetDLLVersion"); // 取得 中介程式 版號
                            resp = obj.send(str);
                        }
                    }
                    if (ATMSessionToken != null) return obj.ParseReturn(resp)
                }
                if (ATMSessionToken != null) return currentVersion
            },
            // 基本功能(版本/錯誤碼/返回值)
            GetErrorCode: function () { // 1
                var str = obj.ExecMethod("GetErrorCode"); // DLL 內部的正確名稱
                if (ATMSessionToken != null) return obj.ParseInt(obj.send(str)); // 返回整數值
            },

            GetVersion: function () { // 3
                return obj.GetAgentVersion();
            },
            GetDLLVersion: function () { // 3
                return obj.GetAgentVersion();
            },

            GetAtmDllVersion :function(){ // BSTR GetAtmDllVersion()
                var str=obj.ExecMethod("GetAtmDllVersion"); // DLL 內部的正確名稱
                if (ATM_sessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetErrorMsg :function(){ // LONG GetErrorMsg()
                var str=obj.ExecMethod("GetErrorMsg");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ConnectCard :function(){ // LONG ConnectCard()
                var str=obj.ExecMethod("ConnectCard");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            DisConnectCard :function(){ // LONG DisConnectCard()
                var str=obj.ExecMethod("DisConnectCard");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            VerifyPin :function(pPin){ // LONG VerifyPin(BSTR pPin)
                var str=obj.ExecMethod("VerifyPin")+obj.ExecParam(pPin);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            VerifyANPin :function(pPin){ // LONG VerifyANPin(LPCTSTR pPin)
                var str=obj.ExecMethod("VerifyANPin")+obj.ExecParam(pPin);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCardType :function(){ // LONG GetCardType()
                var str=obj.ExecMethod("GetCardType");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ReadSN :function(){ // LONG ReadSN()
                var str=obj.ExecMethod("ReadSN");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetSN :function(){ // BSTR GetSN()
                var str=obj.ExecMethod("GetSN")
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            Read1001 :function(){ // LONG Read1001()
                var str=obj.ExecMethod("Read1001");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            Get1001 :function(){ // BSTR Get1001()
                var str=obj.ExecMethod("Get1001")
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ReadCardNo :function(){ // LONG ReadCardNo()
                var str=obj.ExecMethod("ReadCardNo");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetCardNo :function(){ // BSTR GetCardNo()
                var str=obj.ExecMethod("GetCardNo")
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GenerateTAC :function(pData){ // LONG GenerateTAC(BSTR pData)
                var str=obj.ExecMethod("GenerateTAC")+obj.ExecParam(pData);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetTAC :function(){ // BSTR GetTAC()
                var str=obj.ExecMethod("GetTAC")
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GenRandom :function(){ // LONG GenRandom()
                var str=obj.ExecMethod("GenRandom");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetRand :function(){ // BSTR GetRand()
                var str=obj.ExecMethod("GetRand")
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            TermAuth :function(Key, pB64Cryptogram){ // LONG TermAuth(LPCTSTR Key, LPCTSTR pB64Cryptogram)
                var str=obj.ExecMethod("TermAuth")+obj.ExecParam(Key, pB64Cryptogram);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            UnlockANPin :function(){ // LONG UnlockANPin()
                var str=obj.ExecMethod("UnlockANPin")
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ResetANPIN :function(NewPIN){ // LONG ResetANPIN(LPCTSTR NewPIN)
                var str=obj.ExecMethod("ResetANPIN")+obj.ExecParam(NewPIN);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            ClearCard :function(){ // LONG ClearCard()
                var str=obj.ExecMethod("ClearCard")
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetServerAuth :function(){ // LONG GetServerAuth()
                var str=obj.ExecMethod("GetServerAuth");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            GetServerCode :function(){ // BSTR GetServerCode()
                var str=obj.ExecMethod("GetServerCode");
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            VerifyServerResponse :function(ID){ // LONG VerifyServerResponse(BSTR ID)
                var str=obj.ExecMethod("VerifyServerResponse")+obj.ExecParam(ID);
                if (ATMSessionToken != null) return obj.ParseInt(obj.send(str));
            },
            TWNCH1 :function(Idno, Datetime){ // LONG TWNCH1(BSTR ID, BSTR Datetime)
                var str=obj.ExecMethod("TWNCH1")+obj.ExecParam(Idno, Datetime);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            TWNCH2 :function(Idno, Datetime){ // LONG TWNCH2(BSTR ID, BSTR Datetime)
                var str=obj.ExecMethod("TWNCH2")+obj.ExecParam(Idno, Datetime);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            TWNCH3 :function(Money, Datetime, InAccount, OutAccount){ // LONG TWNCH3(BSTR Money, BSTR Datetime, BSTR inAccount, BSTR outAccount)
                var str=obj.ExecMethod("TWNCH3")+obj.ExecParam(Money, Datetime, InAccount, OutAccount);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            FISC1 :function(ClientCheckCode, DateTime, PhoneNo, ID){ // LONG FISC1(BSTR ClientCheckCode, BSTR Datetime, BSTR PhoneNo, BSTR ID)
                var str=obj.ExecMethod("FISC1")+obj.ExecParam(ClientCheckCode, DateTime, PhoneNo, ID);
                if (ATMSessionToken != null) return obj.ParseReturn(obj.send(str));
            },
            doPost1 :function(pin, DateTime){ // LONG FISC1(BSTR ClientCheckCode, BSTR Datetime, BSTR PhoneNo, BSTR ID)
                var str=obj.ExecMethod("doPost1")+obj.ExecParam(pin, DateTime);
                if (ATMSessionToken != null) return obj.ParseInt(obj.send(str));
            },
            // 公應用
            SetCommunityType:function(type){ //
                var str=obj.ExecMethod("SetCommunityType")+obj.ExecParam(type);
                if (capiSessionToken != null) obj.send(str); // 不返回
            }
        }
    }
    window.addEventListener("beforeunload", obj.finalizeAgent);

    return obj;
}

function decimalToHex(d, padding) {
    var hex = Number(d).toString(16);
    padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding;

    while (hex.length < padding) {
        hex = "0" + hex;
    }

    return hex;
}

// Add by TWCA for exposing to window.
window.ATMSessionToken = null;
window.initATMAgentForChromeInIDPaaS = initATMAgentForChrome;
